import React from "react";
import { API } from "../../../const";

export default function TokenIntrouvable() {

    const handleClick = (e) => {
        e.preventDefault();
        window.location.replace(`${API}`)
    };
    return (
        <main className="main-wrapper login-page">
            <div className="container-login">
                <form className="box-login">
                    <h5 class="mb-4">Le lien d’activation a expiré ou votre compte est introuvable</h5>
                    <button type="button" class="btn-gradient mt-4" onClick={handleClick}>
                        Retour
          </button>{" "}
                </form>
            </div>
        </main>
    );
}